import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cajeroData, setCajeroData] = useState(null);
  const [role, setRole] = useState(null);
  const [tipoUsuario, setTipoUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const res = await api.get('/me');
        setUser(res.data.company);
        setCajeroData(res.data.user || null);
        setRole(res.data.role);
        setTipoUsuario(res.data.tipo_usuario);
      } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('token_expires_at');
        localStorage.removeItem('company');
        localStorage.removeItem('punto_venta_id');
        localStorage.removeItem('role');
        localStorage.removeItem('tipo_usuario');
        setUser(null);
        setCajeroData(null);
        setRole(null);
        setTipoUsuario(null);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const res = await api.post('/login', { email, password });
    const { token, company, user: userData, puntos_venta, role, tipo_usuario } = res.data;

    localStorage.setItem('token', token);
    localStorage.setItem('token_expires_at', res.data.expires_at);
    localStorage.setItem('company', JSON.stringify(company));
    localStorage.setItem('role', role);
    localStorage.setItem('tipo_usuario', tipo_usuario);

    if (puntos_venta.length === 1) {
      localStorage.setItem('punto_venta_id', puntos_venta[0].id);
    }

    setUser(company);
    setCajeroData(userData || null);
    setRole(role);
    setTipoUsuario(tipo_usuario);

    return res.data;
  };

  const logout = async () => {
    try {
      await api.post('/logout');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('token_expires_at');
      localStorage.removeItem('company');
      localStorage.removeItem('punto_venta_id');
      localStorage.removeItem('role');
      localStorage.removeItem('tipo_usuario');
      setUser(null);
      setCajeroData(null);
      setRole(null);
      setTipoUsuario(null);
    }
  };

  const isEncargado = tipoUsuario === 'company';
  const isCajero = tipoUsuario === 'cajero';

  return (
    <AuthContext.Provider value={{ 
      user,
      cajeroData,
      role,
      tipoUsuario,
      isEncargado,
      isCajero,
      loading, 
      login, 
      logout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
};